import React from "react";
import Ic from "./Ic";
import { rad, sp } from "../../constants/styles";

const MC = ({ ic, l, v, cl, h, onClick }) => <div onClick={onClick} style={{
  background: h.cd, border: `1px solid ${h.bd}`, borderRadius: rad.lg, padding: "16px 14px",
  cursor: onClick ? "pointer" : "default", transition: "transform 0.2s ease, box-shadow 0.2s ease",
  boxShadow: h.sh
}} onMouseOver={e => { if (onClick) { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = h.s2 || h.sh; } }} onMouseOut={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = h.sh; }}>
  <div style={{ width: 32, height: 32, borderRadius: rad.sm + 2, background: `${cl}10`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: sp.sm }}><Ic n={ic} s={16} c={cl} /></div>
  <div style={{ color: h.tx, fontWeight: 700, fontSize: 20, letterSpacing: "-0.3px", marginBottom: 2 }}>{v}</div>
  <div style={{ color: h.ts || h.sc, fontSize: 11, fontWeight: 500 }}>{l}</div>
</div>;

export default MC;
